import React from 'react';
import { Router as ReachRouter } from '@reach/router';
import './Router.scss';

const Router = (props) => <ReachRouter className="reach-router" {...props} />;

export default Router;
